(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-appointment-general"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('appointment');
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      window.clearAllErrors(form);

      const isValid = window.handleFormValidation(form);
      if (!isValid) {
        return;
      }

      // Form validation
      const firstName = form.querySelector('#firstname');
      const lastName = form.querySelector('#lastname');
      const email = form.querySelector('#email');
      const website = form.querySelector('#website');
      const discussion = form.querySelector('.discussion');

      // Build calendar URL with form data
      const baseUrl = 'https://cal.com/oddit-team/30min';
      const queryParams = new URLSearchParams({
        firstName: firstName.value.trim(),
        lastName: lastName.value.trim(),
        email: email.value.trim(),
        url: website.value.trim(),
        topic: discussion.value,
      });

      window.odditLeadAttribution?.addToBookingParams(queryParams);

      // Open calendar in new tab
      window.open(`${baseUrl}?${queryParams.toString()}`, '_blank');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-appointment"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('appointment');
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      window.clearAllErrors(form);

      const isValid = window.handleFormValidation(form);
      if (!isValid) {
        return;
      }

      // Form validation
      const firstName = form.querySelector('#firstname');
      const lastName = form.querySelector('#lastname');
      const email = form.querySelector('#email');
      const website = form.querySelector('#website');
      const discussion = form.querySelector('.discussion');

      // Build calendar URL with form data
      const baseUrl = 'https://cal.com/oddit-team/30min';
      const queryParams = new URLSearchParams({
        firstName: firstName.value.trim(),
        lastName: lastName.value.trim(),
        email: email.value.trim(),
        url: website.value.trim(),
      });

      window.odditLeadAttribution?.addToBookingParams(queryParams);

      // Open calendar in new tab
      window.open(`${baseUrl}?${queryParams.toString()}`, '_blank');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-oddit-design"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('.free-oddit-design-form');
    if (!form) return;

    const ERROR_BG = '#FFF0F0';
    const ERROR_BORDER = '#FF5C5C';

    function showFieldError(input, message) {
      const wrapper = input.closest('.tw-relative');
      if (!wrapper) return;
      const badge = wrapper.querySelector('.field-error');
      if (badge) { badge.textContent = message; badge.style.display = 'block'; }
      input.style.backgroundColor = ERROR_BG;
      input.style.borderColor = ERROR_BORDER;
    }

    function clearFieldError(input) {
      const wrapper = input.closest('.tw-relative');
      if (!wrapper) return;
      const badge = wrapper.querySelector('.field-error');
      if (badge) { badge.textContent = ''; badge.style.display = 'none'; }
      input.style.backgroundColor = '';
      input.style.borderColor = '';
    }

    function clearAllErrors() {
      form.querySelectorAll('.text-field-input').forEach(function (input) { clearFieldError(input); });
      const errContainer = form.querySelector('.form-errors-container');
      if (errContainer) errContainer.classList.add('hidden');
    }

    form.querySelectorAll('.text-field-input').forEach(function (input) {
      input.addEventListener('input', function () { clearFieldError(input); });
    });

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      clearAllErrors();

      const brandNameInput = form.querySelector('input[name="Brand-Name"]');
      const pageUrlInput = form.querySelector('input[name="Page-URL"]');
      const emailInput = form.querySelector('input[name="Email-Address"]');
      let isValid = true;
      let firstInvalid = null;

      if (!brandNameInput.value.trim()) {
        showFieldError(brandNameInput, 'Required');
        isValid = false;
        if (!firstInvalid) firstInvalid = brandNameInput;
      }

      if (!pageUrlInput.value.trim()) {
        showFieldError(pageUrlInput, 'Required');
        isValid = false;
        if (!firstInvalid) firstInvalid = pageUrlInput;
      }

      if (!emailInput.value.trim()) {
        showFieldError(emailInput, 'Required');
        isValid = false;
        if (!firstInvalid) firstInvalid = emailInput;
      } else if (!/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(emailInput.value.trim())) {
        showFieldError(emailInput, 'Invalid email');
        isValid = false;
        if (!firstInvalid) firstInvalid = emailInput;
      }

      if (!isValid) {
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      const submitBtn = form.querySelector('input[type="submit"]');
      const submitText = submitBtn ? submitBtn.value : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.value = 'Submitting...';
        submitBtn.style.opacity = '0.7';
        submitBtn.style.pointerEvents = 'none';
      }

      try {
        const response = await fetch('https://hook.eu2.make.com/t73f9bve142u1qo9reschvtpnnsi6mi6', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            brand_name: brandNameInput.value.trim(),
            page_url: pageUrlInput.value.trim(),
            email: emailInput.value.trim(),
              ...(window.odditLeadAttribution?.get() || {}),
          }),
        });

        if (response.ok) {
          form.querySelector('.form-posted-successfully')?.classList.remove('hidden');
          form.reset();
          window.location.href = 'https://oddit.co/pages/thank-you';
        } else {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.value = submitText; submitBtn.style.opacity = ''; submitBtn.style.pointerEvents = ''; }
          const formErrorsContainer = form.querySelector('.form-errors-container');
          const errorMessageElement = formErrorsContainer.querySelector('.error-massgage');
          if (errorMessageElement) errorMessageElement.textContent = 'Form submission failed. Please try again.';
          formErrorsContainer.classList.remove('hidden');
        }
      } catch (error) {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.value = submitText; submitBtn.style.opacity = ''; submitBtn.style.pointerEvents = ''; }
        const formErrorsContainer = form.querySelector('.form-errors-container');
        const errorMessageElement = formErrorsContainer.querySelector('.error-massgage');
        if (errorMessageElement) errorMessageElement.textContent = 'Something went wrong. Please try again.';
        formErrorsContainer.classList.remove('hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-trial-oddit-design-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll('.free-trial-oddit-design-v2 .free-trial-oddit-design-form');
    forms.forEach(initForm);

    function initForm(form) {
      const isWebinar = form.dataset.requestType === 'custom_webinar';
      const ERROR_BG = '#FFF0F0';
      const ERROR_BORDER = '#FF5C5C';

      function showFieldError(input, message) {
        const field = input.closest('.field-container');
        if (!field) return;
        const badge = field.querySelector('.field-error');
        if (badge) {
          badge.textContent = message;
          badge.style.display = 'block';
        }
        input.style.backgroundColor = ERROR_BG;
        input.style.borderColor = ERROR_BORDER;
      }

      function clearFieldError(input) {
        const field = input.closest('.field-container');
        if (!field) return;
        const badge = field.querySelector('.field-error');
        if (badge) {
          badge.textContent = '';
          badge.style.display = 'none';
        }
        input.style.backgroundColor = '';
        input.style.borderColor = '';
      }

      function clearAllErrors() {
        form.querySelectorAll('.text-field-input').forEach(function (input) {
          clearFieldError(input);
        });
        const errContainer = form.querySelector('.form-errors-container');
        if (errContainer) errContainer.classList.add('hidden');
      }

      form.querySelectorAll('.text-field-input').forEach(function (input) {
        input.addEventListener('input', function () {
          clearFieldError(input);
        });
      });

      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        clearAllErrors();

        const brandNameInput = form.querySelector('input[name="Brand-Name"]');
        const pageUrlInput = form.querySelector('input[name="Page-URL"]');
        const emailInput = form.querySelector('input[name="Email-Address"]');
        let isValid = true;
        let firstInvalid = null;

        if (!pageUrlInput.value.trim()) {
          showFieldError(pageUrlInput, 'Required');
          isValid = false;
          if (!firstInvalid) firstInvalid = pageUrlInput;
        }


        if (!brandNameInput.value.trim()) {
          showFieldError(brandNameInput, 'Required');
          isValid = false;
          if (!firstInvalid) firstInvalid = brandNameInput;
        }

        if (!emailInput.value.trim()) {
          showFieldError(emailInput, 'Required');
          isValid = false;
          if (!firstInvalid) firstInvalid = emailInput;
        } else if (!/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(emailInput.value.trim())) {
          showFieldError(emailInput, 'Invalid email');
          isValid = false;
          if (!firstInvalid) firstInvalid = emailInput;
        }

        if (!isValid) {
          if (firstInvalid) firstInvalid.focus();
          return;
        }

        const submitBtn = form.querySelector('input[type="submit"]');
        const submitText = submitBtn ? submitBtn.value : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.value = 'Submitting...';
          submitBtn.style.opacity = '0.7';
          submitBtn.style.pointerEvents = 'none';
        }

        try {
          const response = await fetch(isWebinar ? form.dataset.webhookUrl : 'https://hook.eu2.make.com/t73f9bve142u1qo9reschvtpnnsi6mi6', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              ...(window.odditLeadAttribution?.get() || {}),
              ...(isWebinar ? {
                request_type: 'custom_webinar',
                community_url: pageUrlInput.value.trim(),
                industry: brandNameInput.value.trim(),
                submission_page: window.location.origin + window.location.pathname,
              } : {
                // Match the offer rendered by Shoplift, including the original-copy fallback.
                request_type: form.closest('.oddit-test-idea-active') ? 'free_test' : 'free_trial',
                brand_name: brandNameInput.value.trim(),
                page_url: pageUrlInput.value.trim(),
              }),
              email: emailInput.value.trim(),
            }),
          });

          if (response.ok) {
            form.querySelector('.form-posted-successfully')?.classList.remove('hidden');
            form.reset();
            if (isWebinar) {
              form.querySelectorAll('.field-container, .button-container').forEach(element => element.classList.add('hidden'));
              const success = form.querySelector('.form-posted-successfully');
              success.setAttribute('role', 'status');
              success.querySelector('h3')?.focus();
            } else {
              window.location.href = 'https://oddit.co/pages/thank-you';
            }
          } else {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.value = submitText;
              submitBtn.style.opacity = '';
              submitBtn.style.pointerEvents = '';
            }
            const formErrorsContainer = form.querySelector('.form-errors-container');
            const errorMessageElement = formErrorsContainer.querySelector('.error-message');
            if (errorMessageElement) errorMessageElement.textContent = 'Form submission failed. Please try again.';
            formErrorsContainer.classList.remove('hidden');
          }
        } catch (error) {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.value = submitText;
            submitBtn.style.opacity = '';
            submitBtn.style.pointerEvents = '';
          }
          const formErrorsContainer = form.querySelector('.form-errors-container');
          const errorMessageElement = formErrorsContainer.querySelector('.error-message');
          if (errorMessageElement) errorMessageElement.textContent = 'Something went wrong. Please try again.';
          formErrorsContainer.classList.remove('hidden');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-trial-oddit-design"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('.free-trial-oddit-design-form');
    if (!form) return;

    const ERROR_BG = '#FFF0F0';
    const ERROR_BORDER = '#FF5C5C';

    function showFieldError(input, message) {
      const field = input.closest('.field-container');
      if (!field) return;
      const badge = field.querySelector('.field-error');
      if (badge) {
        badge.textContent = message;
        badge.style.display = 'block';
      }
      input.style.backgroundColor = ERROR_BG;
      input.style.borderColor = ERROR_BORDER;
    }

    function clearFieldError(input) {
      const field = input.closest('.field-container');
      if (!field) return;
      const badge = field.querySelector('.field-error');
      if (badge) {
        badge.textContent = '';
        badge.style.display = 'none';
      }
      input.style.backgroundColor = '';
      input.style.borderColor = '';
    }

    function clearAllErrors() {
      form.querySelectorAll('.text-field-input').forEach(function (input) {
        clearFieldError(input);
      });
      const errContainer = form.querySelector('.form-errors-container');
      if (errContainer) errContainer.classList.add('hidden');
    }

    form.querySelectorAll('.text-field-input').forEach(function (input) {
      input.addEventListener('input', function () {
        clearFieldError(input);
      });
    });

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      clearAllErrors();

      const brandNameInput = form.querySelector('input[name="Brand-Name"]');
      const pageUrlInput = form.querySelector('input[name="Page-URL"]');
      const emailInput = form.querySelector('input[name="Email-Address"]');
      let isValid = true;
      let firstInvalid = null;

      if (!brandNameInput.value.trim()) {
        showFieldError(brandNameInput, 'Required');
        isValid = false;
        if (!firstInvalid) firstInvalid = brandNameInput;
      }

      if (!pageUrlInput.value.trim()) {
        showFieldError(pageUrlInput, 'Required');
        isValid = false;
        if (!firstInvalid) firstInvalid = pageUrlInput;
      }

      if (!emailInput.value.trim()) {
        showFieldError(emailInput, 'Required');
        isValid = false;
        if (!firstInvalid) firstInvalid = emailInput;
      } else if (!/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(emailInput.value.trim())) {
        showFieldError(emailInput, 'Invalid email');
        isValid = false;
        if (!firstInvalid) firstInvalid = emailInput;
      }

      if (!isValid) {
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      const submitBtn = form.querySelector('input[type="submit"]');
      const submitText = submitBtn ? submitBtn.value : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.value = 'Submitting...';
        submitBtn.style.opacity = '0.7';
        submitBtn.style.pointerEvents = 'none';
      }

      try {
        const response = await fetch('https://hook.eu2.make.com/t73f9bve142u1qo9reschvtpnnsi6mi6', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            brand_name: brandNameInput.value.trim(),
            page_url: pageUrlInput.value.trim(),
            email: emailInput.value.trim(),
            ...(window.odditLeadAttribution?.get() || {}),
          }),
        });

        if (response.ok) {
          form.querySelector('.form-posted-successfully')?.classList.remove('hidden');
          form.reset();
          window.location.href = 'https://oddit.co/pages/thank-you';
        } else {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.value = submitText;
            submitBtn.style.opacity = '';
            submitBtn.style.pointerEvents = '';
          }
          const formErrorsContainer = form.querySelector('.form-errors-container');
          const errorMessageElement = formErrorsContainer.querySelector('.error-message');
          if (errorMessageElement) errorMessageElement.textContent = 'Form submission failed. Please try again.';
          formErrorsContainer.classList.remove('hidden');
        }
      } catch (error) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.value = submitText;
          submitBtn.style.opacity = '';
          submitBtn.style.pointerEvents = '';
        }
        const formErrorsContainer = form.querySelector('.form-errors-container');
        const errorMessageElement = formErrorsContainer.querySelector('.error-message');
        if (errorMessageElement) errorMessageElement.textContent = 'Something went wrong. Please try again.';
        formErrorsContainer.classList.remove('hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function() {    
    const buttons = document.querySelectorAll('#menu-drawer .menu_drawer_close');
    if (buttons && buttons.length > 0) {
      buttons.forEach((button) => {
        button.onclick = function (event) {
          const detailsElement = this.closest('details');
          if (detailsElement) {
            const summaryElement = detailsElement.querySelector('summary.header__icon');
            if (summaryElement) {
              summaryElement.click();
            }
          }
        };
      });
    } 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const button = document.querySelector('.rich-text-v2 .get-free-design');
    if (button) {
      button.onclick = function (event) {
        this.closest('.rich-text-v2').querySelector('.pop-container-main').classList.add('active');
        document.querySelector('body').classList.add('lock-overflow');
      };
    }

    const closeButton = document.querySelector('.rich-text-v2 .pop-container-main .close-popup');
    if (closeButton) {
      closeButton.onclick = function (event) {
        this.closest('.rich-text-v2').querySelector('.pop-container-main').classList.remove('active');
        document.querySelector('body').classList.remove('lock-overflow');
      };
    }

    const popupForms = document.querySelectorAll('.free-oddit-design-popup-form');
    const ERROR_BG = '#FFF0F0';
    const ERROR_BORDER = '#FF5C5C';

    function showFieldError(input, message) {
      const wrapper = input.closest('.tw-relative');
      if (!wrapper) return;
      const badge = wrapper.querySelector('.field-error');
      if (badge) { badge.textContent = message; badge.style.display = 'block'; }
      input.style.backgroundColor = ERROR_BG;
      input.style.borderColor = ERROR_BORDER;
    }

    function clearFieldError(input) {
      const wrapper = input.closest('.tw-relative');
      if (!wrapper) return;
      const badge = wrapper.querySelector('.field-error');
      if (badge) { badge.textContent = ''; badge.style.display = 'none'; }
      input.style.backgroundColor = '';
      input.style.borderColor = '';
    }

    popupForms.forEach((form) => {
      form.querySelectorAll('.text-field-input').forEach(function (input) {
        input.addEventListener('input', function () { clearFieldError(input); });
      });

      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        form.querySelectorAll('.text-field-input').forEach(function (input) { clearFieldError(input); });
        const errContainer = form.querySelector('.form-errors-container');
        if (errContainer) errContainer.classList.add('hidden');

        const brandNameInput = form.querySelector('input[name="Brand-Name"]');
        const pageUrlInput = form.querySelector('input[name="Page-URL"]');
        const emailInput = form.querySelector('input[name="Email-Address"]');
        let isValid = true;
        let firstInvalid = null;

        if (!brandNameInput.value.trim()) { showFieldError(brandNameInput, 'Required'); isValid = false; if (!firstInvalid) firstInvalid = brandNameInput; }
        if (!pageUrlInput.value.trim()) { showFieldError(pageUrlInput, 'Required'); isValid = false; if (!firstInvalid) firstInvalid = pageUrlInput; }
        if (!emailInput.value.trim()) { showFieldError(emailInput, 'Required'); isValid = false; if (!firstInvalid) firstInvalid = emailInput; }
        else if (!/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(emailInput.value.trim())) { showFieldError(emailInput, 'Invalid email'); isValid = false; if (!firstInvalid) firstInvalid = emailInput; }

        if (!isValid) { if (firstInvalid) firstInvalid.focus(); return; }

        const submitBtn = form.querySelector('input[type="submit"]');
        const submitText = submitBtn ? submitBtn.value : '';
        if (submitBtn) { submitBtn.disabled = true; submitBtn.value = 'Submitting...'; submitBtn.style.opacity = '0.7'; submitBtn.style.pointerEvents = 'none'; }

        try {
          const response = await fetch('https://hook.eu2.make.com/t73f9bve142u1qo9reschvtpnnsi6mi6', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              brand_name: brandNameInput.value.trim(),
              page_url: pageUrlInput.value.trim(),
              email: emailInput.value.trim(),
              ...(window.odditLeadAttribution?.get() || {}),
            }),
          });

          if (response.ok) {
            form.querySelector('.form-posted-successfully')?.classList.remove('hidden');
            form.reset();
            window.location.href = 'https://oddit.co/pages/thank-you';
          } else {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.value = submitText; submitBtn.style.opacity = ''; submitBtn.style.pointerEvents = ''; }
            form.querySelector('.form-errors-container')?.classList.remove('hidden');
          }
        } catch (error) {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.value = submitText; submitBtn.style.opacity = ''; submitBtn.style.pointerEvents = ''; }
          form.querySelector('.form-errors-container')?.classList.remove('hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
